import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getAllSkills, getSkillLevels, getWorkerSkillsAction, changeWorkerSkillAction, deleteWorkerSkillAction,
  addWorkerSkillAction } from '../../../actions/skills';
import ActiveWorkerSkill from './ActiveWorkerSkill';
import { getAvailableSkills, getBasicSkillLevelId } from '../../../helpers/general';

class WorkerSkills extends Component {
  static propTypes = {
    workerId: PropTypes.number.isRequired,
    skillsList: PropTypes.array.isRequired,
    skillLevels: PropTypes.array.isRequired,
    workerSkills: PropTypes.array.isRequired,
    getAllSkills: PropTypes.func.isRequired,
    getSkillLevels: PropTypes.func.isRequired,
    getWorkerSkillsAction: PropTypes.func.isRequired,
    changeWorkerSkillAction: PropTypes.func.isRequired,
    deleteWorkerSkillAction: PropTypes.func.isRequired,
    addWorkerSkillAction: PropTypes.func.isRequired
  };

  state = {
    newSkillId: 0,
    newSkillLevelId: 0
  };

  componentDidMount = () => {
    const { getAllSkills, getSkillLevels } = this.props;
    getAllSkills();
    getSkillLevels().then(this.setBasicSkillLevel);
    this._getWorkerSkills();
  };

  _resetState = () => this.setState({ newSkillId: 0 });

  _getWorkerSkills = () => this.props.getWorkerSkillsAction(this.props.workerId);

  setBasicSkillLevel = () => this.setState({
    newSkillLevelId: getBasicSkillLevelId(this.props.skillLevels)
  });

  selectNewSkill = event => this.setState({
    newSkillId: parseInt(event.target.value, 10)
  });

  addSkill = event => {
    event.preventDefault();
    const { addWorkerSkillAction, workerId } = this.props;
    const { newSkillId, newSkillLevelId } = this.state;
    addWorkerSkillAction(workerId, newSkillId, newSkillLevelId)
      .then(this._getWorkerSkills)
      .then(this._resetState);
  };

  render () {
    const { workerSkills, skillsList, skillLevels, changeWorkerSkillAction, getWorkerSkillsAction, workerId,
      deleteWorkerSkillAction } = this.props;
    const availableSkills = getAvailableSkills(skillsList, workerSkills);

    return (
      <section className='skill-info'>
        <h4 className='section-header'>Skills</h4>
        { workerSkills.length > 0 ? workerSkills.map((activeSkill, i) => (
          <ActiveWorkerSkill
            key={i}
            skill={activeSkill}
            skillLevels={skillLevels}
            changeWorkerSkillAction={changeWorkerSkillAction}
            getWorkerSkillsAction={getWorkerSkillsAction}
            deleteWorkerSkillAction={deleteWorkerSkillAction}
            workerId={workerId}
          />
        )) : (
          <p>There is no active skills</p>
        )}
        <form onSubmit={this.addSkill} hidden={!availableSkills.length}>
          <h5 className='add-skill'>Add New Skill</h5>
          <select
            className='styled-select select-skill'
            value={this.state.newSkillId}
            onChange={this.selectNewSkill}
          >
            <option disabled value='0'>Select skill</option>
            {availableSkills.map(skill =>
              <option value={skill.job_skill_id} key={skill.id}>
                {skill.skill_label}
              </option>
            )}
          </select>
          <button disabled={!this.state.newSkillId} className='button button-primary mt-3'>Add Skill</button>
        </form>
      </section>
    );
  }
}

const mapStateToProps = state => {
  return {
    skillsList: state.skillsList,
    skillLevels: state.skillLevels,
    workerSkills: state.worker.workerSkills
  };
};

const mapDispatchToProps = {
  getAllSkills,
  getSkillLevels,
  getWorkerSkillsAction,
  changeWorkerSkillAction,
  deleteWorkerSkillAction,
  addWorkerSkillAction
};

export default connect(mapStateToProps, mapDispatchToProps)(WorkerSkills);



// WEBPACK FOOTER //
// ./src/components/app/workerDetails/WorkerSkills.js